import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash/fp';
import { Fade, Snackbar } from '@material-ui/core';

import { ERROR_DISPLAY_TYPE } from '../../constants';
import RetryDialog from '../RetryDialog';

const ErrorDisplay = () => {
  const [open, setOpen] = useState(false);

  const error = useSelector(state => state.errors);

  const dispatch = useDispatch();

  const handleClose = () => setOpen(false);
  const handleRetry = () => {
    setOpen(false);

    if (error.onRetry) {
      error.onRetry();
    }
  };

  useEffect(() => {
    if (error) {
      setOpen(true);
    }
  }, [dispatch, error]);

  if (!get('type', error)) {
    return null;
  }

  if (get('type', error) === ERROR_DISPLAY_TYPE.DIALOG) {
    return (
      <RetryDialog open={open} onClose={handleClose} onRetry={handleRetry}>
        {error.message}
      </RetryDialog>
    );
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={3500}
      TransitionComponent={Fade}
      ContentProps={{
        'aria-describedby': 'errorMessage',
      }}
      message={(
        <span id="errorMessage">
          {error.message}
        </span>
      )}
      onClose={handleClose}
    />
  );
};
export default ErrorDisplay;
